export default __webpack_public_path__ + "media/images/favicon-67c70f3c5ec513665bd42c8584543123.svg";